import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import WorksPage from "@/pages/works/page";
import WorkDetailPage from "@/pages/works/detail/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "works",
        element: <WorksPage />,
      },
      {
        path: "works/detail/:id",
        element: <WorkDetailPage />,
      },
      {
        path: "news",
        element: <NewsPage />,
      },
      {
        path: "news/detail/:id",
        element: <NewsDetailPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;